module.exports = __webpack_public_path__ + "static/media/sumofame.61243bf1.svg";